import jsPDF from 'jspdf';
import 'jspdf-autotable';
import formatPrice from 'utils/formatPrice';
import sortInsurance from 'utils/sortInsurance';

const patientInsuranceToPDF = ({ inputPDF, patient }) => new Promise((resolve) => {
  const lineHeight = 1.2;
  const margin = 10;
  const ptsPerMm = 2.834646;
  const fontSize = 10;
  const titleFontSize = 18;
  const fontType = 'normal';
  const textColor = 0;
  const drawColor = 0;
  const lineHeightMm = fontSize * (lineHeight / ptsPerMm);
  const format = 'a4';
  // eslint-disable-next-line new-cap
  const doc = inputPDF || new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format,
    lineHeight,
  });
  if (inputPDF) {
    doc.addPage(format);
  }
  doc.setFont('times');
  let y = margin;
  let x = margin;
  const pageContentWidth = doc.internal.pageSize.getWidth() - (margin * 2);
  let maxWidth = pageContentWidth;
  const setDefaults = () => {
    doc.setFontSize(fontSize);
    doc.setFontType(fontType);
    doc.setTextColor(textColor);
    doc.setDrawColor(drawColor);
  };
  const addY = (newY) => {
    if ((y + newY) < doc.internal.pageSize.getHeight() - (margin * 2)) {
      y += newY;
    } else {
      doc.addPage();
      y = margin;
    }
  };
  const renderTitle = () => {
    doc.setFontSize(titleFontSize);
    doc.setFontType('bold');
    x = (doc.internal.pageSize.getWidth() / 2);
    maxWidth = pageContentWidth * 0.75;
    const text = doc.splitTextToSize(`${patient['Last Name']}, ${patient['First Name']} Insurance Information`, maxWidth);
    text.forEach((line) => {
      addY(titleFontSize * (lineHeight / ptsPerMm));
      doc.text(line, x, y, null, null, 'center');
    });
    addY(margin / 2);
  };
  const renderPatientInsurance = () => {
    const insurances = patient['Insurance Information'].filter(item =>
      item['Insurance Type'] !== 'Self');
    setDefaults();
    addY(lineHeightMm);
    x = margin;
    maxWidth = pageContentWidth;
    if (insurances.length > 0) {
      const columns = [
        { title: 'Payer', dataKey: 'payerName' },
        { title: 'Order of\n Benefits', dataKey: 'orderBenefits' },
        { title: 'Type', dataKey: 'type' },
        { title: 'Insurance ID, Group ID', dataKey: 'insuranceID' },
        { title: 'Effective From/To', dataKey: 'effectiveFromTo' },
        { title: 'Copay', dataKey: 'copay' },
        { title: 'Status', dataKey: 'status' },
        { title: 'Comments', dataKey: 'comments' },
      ];
      const rows = sortInsurance(insurances)
        .map((item) => {
          const effectiveDates = item['Effective From'] && item['Effective To']
            ? `${item['Effective From']} - ${item['Effective To']}` : '';
          let copay;
          switch (item['Copay Type']) {
            case 'Fixed':
              copay = formatPrice(item['Copay Amount']);
              break;
            case 'Percent':
              copay = `${item['Copay Amount']}%`;
              break;
            default:
              copay = '';
          }
          return {
            payerName: item['Insurance Info']['Payer Name'],
            orderBenefits: item['Order Benefits'],
            type: item['Claim Filling Code'] && item['Claim Filling Code']['Full Name']
              ? item['Claim Filling Code']['Full Name'] : '',
            insuranceID: item['Group ID'] ? `${item['Insurance ID']}, ${item['Group ID']}` : item['Insurance ID'],
            effectiveFromTo: effectiveDates,
            copay,
            status: item['Insurance Status'],
            comments: item.Comments ? item.Comments : '',
          };
        });
      doc.autoTable(columns, rows, {
        theme: 'grid',
        startY: y,
        showHeader: 'everyPage',
        margin: [0, 0, 0, x],
        tableWidth: maxWidth,
        styles: {
          font: 'times',
          textColor,
          lineColor: drawColor,
          fontSize,
          cellPadding: [0, margin / 4, 0, margin / 4],
          columnWidth: 'auto',
          overflow: 'linebreak',
        },
        headerStyles: {
          lineWidth: 0.1,
          lineColor: drawColor,
          fillColor: 'white',
        },
        columnStyles: {
          orderBenefits: {
            columnWidth: 22,
          },
          type: {
            columnWidth: 25,
          },
          insuranceID: {
            columnWidth: 27,
          },
          effectiveFromTo: {
            columnWidth: 24,
          },
          copay: {
            columnWidth: 'wrap',
          },
          status: {
            columnWidth: 'wrap',
          },
          comments: {
            columnWidth: 25,
          },
        },
      });
      const table = doc.autoTable.previous;
      addY((table.finalY - y) + margin);
    } else {
      doc.text('Patient has no Insurance', x, y);
      addY(margin);
    }
  };

  renderTitle();
  renderPatientInsurance();
  resolve(doc);
});

export default patientInsuranceToPDF;



// WEBPACK FOOTER //
// ./src/utils/patientInsuranceToPDF.js